import { FC, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/redux/createAction';
import { actionsCompany } from 'src/pages/CompanyPage/_BLL/slice';
import { RequestStatus } from 'src/shared/api/types';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import { ButtonSecondary } from 'src/shared/ui/_buttons/ButtonSecondary';
import { ButtonsWrapper } from 'src/shared/ui/_layout/ButtonsWrapper';
import { Heading } from 'src/shared/ui/Heading';
import { Modal } from 'src/shared/ui/Modal/Modal';
import { Paragraph } from 'src/shared/ui/Paragraph';

interface Props {
	companyId: number;
}

export const UpdateCompanyData: FC<Props> = (props) => {
	const { companyId } = props;

	const [isModalOpen, setIsModalOpen] = useState(false);
	const toggleModal = () => setIsModalOpen((prevState) => !prevState);

	// * Selectors
	const status = useAppSelector((state) => state.company.status);

	// * Actions
	const dispatch = useAppDispatch();
	const { refreshCompany } = actionsCompany;

	const onYesClick = () => {
		dispatch(refreshCompany({ params: { id: companyId } }));
	};

	// * Conditions
	const isLoading = status === RequestStatus.loading;

	// * Render
	return (
		<>
			<Modal
				isOpen={isModalOpen}
				onClose={toggleModal}
				maxWidth="40rem"
			>
				<Heading
					level={1}
					marginBottom="m"
				>
					Refresh to latest data available
				</Heading>

				<Paragraph>
					Are you sure you want to update your company data to the latest available to Denominator? This action would replace any data, including those you&apos;ve manually entered.
				</Paragraph>

				<ButtonsWrapper>
					<ButtonPrimary
						onClick={onYesClick}
						loading={isLoading}
					>
						Yes
					</ButtonPrimary>

					<ButtonSecondary
						onClick={toggleModal}
						loading={isLoading}
					>
						No
					</ButtonSecondary>
				</ButtonsWrapper>
			</Modal>

			<ButtonSecondary
				onClick={toggleModal}
				style={{ height: '3.5rem' }}
			>
				<span>
					Refresh to latest <br /> data available
				</span>
			</ButtonSecondary>
		</>
	);
};
